/**
 * VendorMark — marcas de terceiros (AWS, GCP, Azure, Apple, WhatsApp) em grupo separado dos ícones, sempre
 * monocromáticas na cor do texto da superfície (cap. 08; D15). Os glifos oficiais entram na F8 em src/brand/vendors/*.svg
 * (SVG oficial de cada marca, fill/stroke normalizados para currentColor, sem cor de terceiro — nem o verde do WhatsApp).
 * Enquanto a pasta estiver vazia renderiza o nome em mono, nunca um logo colorido.
 */
const registry = import.meta.glob('./vendors/*.svg', { query: '?raw', import: 'default', eager: true }) as Record<string, string>
const byName: Record<string, string> = Object.fromEntries(Object.entries(registry).map(([p, svg]) => [p.replace(/^.*\/(.+)\.svg$/, '$1'), svg]))

export type Vendor = 'aws' | 'gcp' | 'azure' | 'apple' | 'whatsapp'
const LABEL: Record<Vendor, string> = { aws: 'AWS', gcp: 'Google Cloud', azure: 'Microsoft Azure', apple: 'Apple', whatsapp: 'WhatsApp' }

export function VendorMark({ vendor, size = 24, className }: { vendor: Vendor; size?: number; className?: string }) {
  const svg = byName[vendor]
  if (!svg) return <span className={['z-dado', className].filter(Boolean).join(' ')} data-vendor={vendor}>{LABEL[vendor]}</span>
  return (
    <span
      className={['z-icon', className].filter(Boolean).join(' ')}
      style={{ width: size, height: size }}
      role="img"
      aria-label={LABEL[vendor]}
      data-vendor={vendor}
      dangerouslySetInnerHTML={{ __html: svg }}
    />
  )
}

export default VendorMark
